import debounce from 'debounce';

class AppResizableAreas {
  constructor($document, $timeout, $window, appUtils) {
    'ngInject';

    [this.$document] = Array.from($document);
    this.$timeout = $timeout;
    this.$window = $window;
    this.appUtils = appUtils;
    this._listening = false;
    this._stopListening = () => {};
    this._listeners = {};

    this._selectorsTemplates = {
      target: '[data-app-resizable-area=":name"]',
      siblings: '[data-app-resizable-area-siblings=":name"]',
    };

    const debounceTime = 300;
    this._listener = debounce(this._listener, debounceTime);
    this._listener = this._listener.bind(this);
  }
  setTargetSelectorTemplate(querySelector) {
    this._selectorsTemplates.target = querySelector;
  }
  setSiblingsSelectorTemplate(querySelector) {
    this._selectorsTemplates.siblings = querySelector;
  }
  listen(name) {
    if (this._listeners[name]) {
      throw new Error(`There's another listener using the same name: ${name}`);
    }

    const { target, siblings } = this._selectorsTemplates;
    this._listeners[name] = {
      target: target.replace(':name', name),
      siblings: siblings.replace(':name', name),
    };

    if (!this._listening) {
      const waitForDOM = 300;
      this.$timeout(() => this._start(), waitForDOM);
    }

    return {
      remove: () => this.remove(name),
      update: () => this.update(name),
    };
  }
  remove(name) {
    delete this._listeners[name];
    if (this._listening && !Object.keys(this._listeners)) {
      this._stop();
    }
  }
  update(name = '') {
    if (name) {
      if (!this._listeners[name]) {
        throw new Error(`There's no listener registered with the name: ${name}`);
      }

      this._updateElement(name);
    } else {
      this._listener();
    }
  }
  _start() {
    this._listening = true;
    this._stopListening = this.appUtils.attachWindowEvents('resize', this._listener);
    this.update();
  }
  _stop() {
    this._stopListening();
    this._listening = false;
  }
  _listener() {
    Object.keys(this._listeners).forEach((name) => {
      this._updateElement(name);
    });
  }
  _updateElement(name) {
    const selectors = this._listeners[name];
    const element = this.$document.querySelector(selectors.target);
    if (element) {
      const parent = element.parentElement;
      const siblings = [...this.$document.querySelectorAll(selectors.siblings)];

      let newHeight = parent.offsetHeight;
      let substract = 0;
      siblings.forEach((sibling) => {
        substract += sibling.offsetHeight;
      });

      newHeight -= substract;
      const { style: { height } } = element;
      if (!height || newHeight !== parseInt(height, 10)) {
        element.style.height = `${newHeight}px`;
      }
    }
  }
}

export default AppResizableAreas;
